/* javascript product function to update form field
 */
function Product() {
	var self = this;
	this.initList = function() {
		jQuery(function() {
			//$('#zoom01, .cloud-zoom-gallery').CloudZoom();
			self.countSpecial();
			$('#productform').submit(function() {
				var ra = $('#productform').find('input:radio');
				//console.log(ra);
				if (ra.length) {
					var flag = false;
		
					$('#productform input:radio').each(function() {
						if ($(this).is(':checked')) {
							flag = true;
						}
		
					});
					if (!flag) {
						$('.product_attributes').addClass('attalert fade in');
						$('#productAttributes').append('<div class="alert alert-danger fade in" id="proattralert"><a class="close" href="#" data-dismiss="alert"> × </a>Please choose product option before add to cart</div>');
					}
		
					return flag;
				} else {
					return true;
				}
			});
			$("#productAttributes :radio").click(function() {
				$('.product_attributes').removeClass('attalert');
				$('#proattralert').alert('close');
		
			});

			var imagesele = $("#zoomimage").elevateZoom({
				gallery: 'image_gallery',
				cursor: 'pointer',
				galleryActiveClass: 'actives',
				//imageCrossfade: true,
				responsive: true,

			});
			$("#zoomimage").bind("click", function(e) {
				var ez = $('#zoomimage').data('elevateZoom');
				$.fancybox(ez.getGalleryList());
				return false;
			});
			$('#procarousel').carousel({
				interval: 6000
			});
			$(".moveleft").click(function() {
				event.preventDefault();
				$("#procarousel").carousel("prev");
			});
			$(".moveright").click(function() {
				event.preventDefault();
				$("#procarousel").carousel("next");
			});

			$('body').on('click', '#savebtn', function() {
				var theone = $('#askform');
				$.ajax({
					url: '/ajaxfaq/',
					type: 'post',
					data: theone.serialize(),
					dataType: 'json',
					beforeSend: function() {
						$('.ajmessage, .ajax-loading').remove();
						$('#savebtn').prepend('<img class="ajax-loading" style="margin-right:10px;" src="./images/ajax-loading.gif" />');
					},
					success: function(data) {
						if (data.status) {
							layer.msg(data.msg, {
								icon: 1
							}, function() {
								$('#faqsub').val('');
								$('#faqmes').val('');
								$('#askquestions').modal('hide');
							});
						} else {
							self.reloadFaqcaptcha();
							layer.msg(data.msg, {
								icon: 2
							});
						}
					},
					complete: function() {
						$('.ajax-loading').remove();
					}
				});

			});
			
			self.getshippingcountry();



			$('body').on('change', '#countryfee', function() {
				self.getshippingtable();
			});


			$('#productadditionimage').Thumbelina({
				$bwdBut: $('#productadditionimage .left'), // Selector to left button.
				$fwdBut: $('#productadditionimage .right') // Selector to right button.
			});


			$('body').on('click', '.attrimg', function() {
				var fullattr = $(this).parent().parent().parent();
				fullattr.children().children().find("img").removeClass('checkimg');
				var radios = $(this).parent().find("input:radio").eq(0).attr("checked", "checked");
				$(this).addClass('checkimg');
				var img = $(this).parent().find("input:hidden").val();
				var largeimg = $(this).parent().find("input[name='large_image']").val();
				var middleimg = $(this).parent().find("input[name='middle_image']").val();

				//$('#zoomimage').attr('src', img);
				var imagesele = $("#zoomimage").data('elevateZoom');
				imagesele.swaptheimage(middleimg, largeimg);

			});

			$(".additionimg").mouseover(function() {
				$(this).parent().parent().parent().find('li').removeClass('chooseimg');

				$(this).parent().parent().addClass('chooseimg');
				var img = $(this).parent().find('.hiddimg').val();
				//$('#zoomimage').attr('src', img);
				//$('#zoom01').attr('href', img);
				//$('#zoom01, .cloud-zoom-gallery').CloudZoom();

			});

			$('body').on('click', '.gaddwish', function() {
				var id = $(this).attr('data');
				var self = $(this);
				$.ajax({
					type: 'post',
					data: {
						'doact': 'addwishlist',
						'products_id': id
					},
					url: '/ajaxaddwish/',
					dataType: 'json',
					success: function(data) {
						if (data.status) {
							self.find('i').addClass('fa-check');
							self.find('i').removeClass('fa-heart');
							self.find('span').html('Add Wishlist Success');
							self.removeClass('gaddwish');
							self.addClass("saddwish");
						} else {
							if (data.code == 2) {
								var url = $('#loginbtn').attr('datesrc');
								loginframe(url);
							} else {
								layer.msg(data.msg);
							}

						}
					}


				});
			});



			$('body').on('click', '.saddwish', function() {
				var id = $(this).attr('data');
				var self = $(this);
				$.ajax({
					type: 'post',
					data: {
						'doact': 'removewishlist',
						'products_id': id
					},
					url: '/ajaxaddwish/',
					dataType: 'json',
					success: function(data) {
						if (data.status) {
							self.find('i').removeClass('fa-check');
							self.find('i').addClass('fa-heart');
							self.find('span').html('Add wish');
							self.removeClass('saddwish');
							self.addClass("gaddwish");
						} else {
							if (data.code == 2) {
								var url = $('#loginbtn').attr('datesrc');
								loginframe(url);
							} else {
								layer.msg(data.msg);
							}

						}
					}


				});

			});
			$('#sharegg').sharegg({

				apiUrl: '/socialmedia/',

				buttons: {

					facebook: {

						show: true,

						count: true,

					},

					googleplus: {

						show: true,

						count: true,

					},

					linkedin: {

						show: true,

						count: true,

					},

					pinterest: {

						show: true,

						count: true,

					},

					reddit: {

						show: true,

						count: true,

					},


					twitter: {

						show: true,

						count: true,

					},

					vkontakte: {

						show: true,

						count: true,

					}

				}



			});
		});
		
		$('body').on('click', '#faqcaptcha-img', function() {
			self.reloadFaqcaptcha();
		});
		$('#askquestions').on('shown.bs.modal', function () {
			$('#faqcaptcha').val('');
			$('#faqcapchspan').html('<img width="90" height="30" title="captcha" alt="reload..." src="" id="faqcaptcha-img">');
			// var zendid = $('#zendid').val();
			$('#faqcaptcha-img').attr('src', '/captchaimg/?type=faqcode&rand=' + Math.random());
		});
		
		
	};
	this.countSpecial=function(){
		
			if($('#specialenddate').length){
				var speDate=$('#specialenddate').val();
				
			$('#clock').countdown(speDate).on('update.countdown', function(event) {
			var format = '%H:%M:%S';
			if(event.offset.days > 0) {
			format = '%-d day%!d ' + format;
			}
			if(event.offset.weeks > 0) {
			format = '%-w week%!w ' + format;
			}
			$(this).html('<i class="fa fa-clock-o" aria-hidden="true"></i>Special Time Only: '+event.strftime(format));
			$('#limittime').removeClass("hidden");
			
			}).on('finish.countdown', function(event) {
				$('#limittime').addClass("hidden");
			});
		}
	};
	this.reloadFaqcaptcha=function(){
		
		$('#faqcaptcha-img').attr('src', '');
		
		$('#faqcaptcha-img').attr('src', '/captchaimg/?type=faqcode&rand=' + Math.random());
		$('#faqcaptcha').val('');
	};
	this.getshippingtable = function() {
		jQuery(document).ready(function($) {
			var countryoptions = $("#countryfee").val();
			var proid = $('input[name=products_id]').val();

			$.ajax({
				url: '/ajaxship/',
				data: {
					'zone_country_id': countryoptions,
					'product_id': proid,
					'actions': 'getshipfee'
				},
				dataType: 'json',
				type: 'POST',
				success: function(data) {
					if (data.status) {
						tbdy = '';
						$.each(data.data, function(i, v) {
							tbdy += '<tr><td><div>' + v.icon + '</div></td><td>' + v.cost + '</td><td>' + v.time + '</td></tr>';
						});
						$('#shipcontent').html(tbdy);
					}
				}

			});
		});
	};
	this.getshippingcountry = function() { //get shipping country
		jQuery(document).ready(function($) {
			$.ajax({
				url: '/ajaxship/',
				data: {
					'actions': 'getcountry'
				},
				dataType: 'json',
				type: 'POST',
				success: function(data) {
					if (data.status) {
						var str = "";
						$.each(data.data, function(i, v) {
							str += '<option value="' + v.countries_id + '">' + v.countries_name + '</option>';
						});
						$('#countryfee').html(str);
						$('#countryfee').val("223");
						self.getshippingtable();
					}
				}

			});
		});
	};

}

window.gProduct = new Product();